import { Link, NavLink } from "react-router-dom";
import { SUPPORT_EMAIL } from "@/lib/site";

const LINKS = [
  { to: "/features", label: "Features", testId: "nav-features" },
  { to: "/how-it-works", label: "How it works", testId: "nav-how-it-works" },
  { to: "/business", label: "For Business", testId: "nav-business" },
];

const linkClass = ({ isActive }) =>
  `transition-colors duration-300 ${isActive ? "text-[#4FE3E0]" : "text-zinc-300 hover:text-white"}`;

export const Navbar = () => (
  <header
    data-testid="main-nav"
    className="fixed top-0 inset-x-0 z-50 bg-[#0A0E0D]/85 backdrop-blur-xl border-b border-white/5"
  >
    <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
      <Link
        to="/"
        data-testid="nav-logo"
        className="font-extrabold text-sm tracking-[0.2em] text-[#4FE3E0] hover:text-[#F4F4F0] transition-colors duration-300"
      >
        PULL UP
      </Link>

      <nav className="flex items-center gap-5 sm:gap-8 text-sm">
        {LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} data-testid={l.testId} className={linkClass}>
            {l.label}
          </NavLink>
        ))}
        <a
          data-testid="nav-support"
          href={`mailto:${SUPPORT_EMAIL}`}
          className="hidden sm:inline text-zinc-300 hover:text-white transition-colors duration-300"
        >
          Support
        </a>
        <NavLink to="/privacy" data-testid="nav-privacy" className={linkClass}>
          Privacy
        </NavLink>
      </nav>
    </div>
  </header>
);
